module.exports = "/_next/static/images/image7-0a614f7a60472b8ca7414eb9e293fe0e.png";